module.exports = __webpack_public_path__ + "img/11.01e7dc35.jpg";